import React, { Component } from 'react';
import { connect } from "react-redux";

import axios from "axios";
import { withRouter } from 'react-router-dom';
import { debounce } from "lodash";

import { LoadingIcon } from '../../../Common/Loading_Icon';
import { setList, setOverlay } from '../../../../Actions/stakeholderActions';
import { setProfileDb } from '../../../../Actions/dataActions';
import { constants } from '../../../../Helpers/Constants';
import { Trans } from 'react-i18next';
import PopupModal from '../../../Common/DesignSystem/PopupModal';
import colours from '../../../Common/DesignSystem/Colours';
import { Input } from '../../../Common/DesignSystem/Input';
import Button from '../../../Common/DesignSystem/Button';


class DeactivateUserOverlay extends Component {
    constructor(props) {    
        super(props);

        this.state = {
            loading_deactivate: true,
            name: "",
            type: "",
            bookings_message: 0,
            notes: "",
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = debounce(this.handleSubmit.bind(this), 500);
    }

    componentDidMount() {
        if (this.props.match.params.id) {

            var self = this;
            axios.post('/ajax/profile/' + this.props.match.params.id + '/deactivate')
            .then(function(response) {
                self.setState({
                    name: response?.data.name,
                    type: response?.data.type,
                    bookings_message: response?.data.bookings_message,
                    loading_deactivate: false
                })


            })
            .catch(function(error) {
                if(error.response?.status == 401){
                    showStatusMsg(error.response?.data.error);
                } else if(error.response?.status == 422) {
                    var error_message = "";

                    $.each(error.response?.data.errors, function (index, element) {
                        error_message += element + '<br />';
                    });

                    showStatusMsg(error_message);
                } else {
                    showStatusMsg("Requested information not found");
                }

                if (self.props.closeModal) self.props.closeModal();
            })
        }
    }

    componentWillReceiveProps(nextProps) {
    }

    handleChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;
    
        this.setState({
          [name]: value
        });
    }

    handleSubmit(e, props) {
        var self = this;
        var url = '/ajax/profile/' + this.props.match.params.id + '/deactivate/notes';

        if(this.state.type == "internaltag_deactivate") {
            url = '/ajax/profile/' + this.props.match.params.id + '/deactivateinternal';
        }

        axios({
            method: 'post',
            url: url,
            data: {notes: self.state.notes},
            config: { headers: {'Content-Type': 'multipart/form-data' }}
        })
        .then((response) => {
            axios.get('/ajax/profile/' + self.props.match.params.id)
            .then(function(response2) {
                self.props.dispatch(setProfileDb([response2.data.profile], self.props.data.profile_db))
                self.props.dispatch(setOverlay("SET_CURRENT_PROFILE_DETAILS", response2.data))
            })
            .catch(function(error) {
                if(error.response?.status == 401){
                    showStatusMsg(error.response?.data.error);
                } else if(error.response?.status == 422) {
                    var error_message = "";

                    $.each(error.response?.data.errors, function (index, element) {
                        error_message += element + '<br />';
                    });

                    showStatusMsg(error_message);
                } else {
                    showStatusMsg("Requested information not found");
                }
            })

            if(self.props.match.url.split("/")[1] === "useroverview") {
                var data = {
                    search_term: self.props.stakeholder.previous_filters.search,
                    sort_filter: self.props.stakeholder.sort_filter,
                    sort_direction: self.props.stakeholder.sort_direction,
                    bookings_min: self.props.stakeholder.previous_filters.bookings.min,
                    bookings_max: self.props.stakeholder.previous_filters.bookings.max,
                    last_booking_min: self.props.stakeholder.previous_filters.last_booking.min,
                    last_booking_max: self.props.stakeholder.previous_filters.last_booking.max,
                    member_min: self.props.stakeholder.previous_filters.member.min,
                    member_max: self.props.stakeholder.previous_filters.member.max
                }


                var filters = self.props.stakeholder.previous_filters;
                var categories = Object.keys(filters);
                for (var i = 0; i < categories.length; i++) {
                    data[categories[i]] = "";
                    if (categories[i] !== "bookings" || categories[i] !== "last_booking" || categories[i] !== "member") {
                        var items = Object.keys(filters[categories[i]]);
                        for (var k = 0; k < items.length; k++) {
                            if (filters[categories[i]][items[k]] === true) {
                                if (data[categories[i]] === "") {
                                    data[categories[i]] = items[k]
                                } else {
                                    data[categories[i]] = data[categories[i]] + "#" + items[k]
                                }
                            }
                        }
                    }
                }

                axios({
                    method: 'post',
                    url: '/ajax/user_list/update',
                    data: data
                })
                .then(function(response2) {
                    self.props.dispatch(setProfileDb(response2.data.data.data, self.props.data.profile_db));
                    self.props.dispatch(setList("SET_USER_LIST", response2.data.data.data))
                })
                .catch(function(error) {
                    if(error.response?.status == 401){
                        showStatusMsg(error.response?.data.error);
                    } else if(error.response?.status == 422) {
                        var error_message = "";

                        $.each(error.response?.data.errors, function (index, element) {
                            error_message += element + '<br />';
                        });

                        showStatusMsg(error_message);
                    } else {
                        showStatusMsg("Requested information not found");
                    }
                })
            }

            if(self.props.match.url.split("/")[1] === "tiers") {
                axios({
                    method: 'post',
                    url: '/ajax/tiers/users',
                    data: { search_term: $("#searchbar").val(),
                            vmh: $("input[name='vmh[]']:checked").map(function () { return this.value; }).get().join('#'), 
                            sh: $("input[name='sh[]']:checked").map(function () { return this.value; }).get().join('#'), 
                            tier: $("input[name='tier[]']:checked").map(function () { return this.value; }).get().join('#'), 
                            company: $("input[name='company[]']:checked").map(function () { return this.value; }).get().join('#'), 
                            title: $("input[name='title[]']:checked").map(function () { return this.value; }).get().join('#'), 
                            last_booking_min: $("#last_booking_min").text(),
                            last_booking_max: $("#last_booking_max").text(),
                            bookings_min: $("#bookings_min").text(),
                            bookings_max: $("#bookings_max").text(),
                            sort_filter: $("#sort_filter").val(),
                            sort_direction: $("#sort_direction").val(),
                        }
                })
                .then(function(response2) {
                    self.props.dispatch(setList("SET_USER_TIER_LIST", response2.data.data.data))
                })
                .catch(function(error) {
                    if(error.response?.status == 401){
                        showStatusMsg(error.response?.data.error);
                    } else if(error.response?.status == 422) {
                        var error_message = "";
        
                        $.each(error.response?.data.errors, function (index, element) {
                            error_message += element + '<br />';
                        });
        
                        showStatusMsg(error_message);
                    } else {
                        showStatusMsg("Requested information not found");
                    }
                })
            }

            showStatusMsg(response?.data.message, 'success');
            self.props.history.goBack();
        })
        .catch(function(error) {
            if(error.response?.status == 401){
                showStatusMsg(error.response?.data.error);
            } else if(error.response?.status == 422) {
                var error_message = "";

                $.each(error.response?.data.errors, function (index, element) {
                    error_message += element + '<br />';
                });

                showStatusMsg(error_message);
            } else {
                showStatusMsg("Requested information not found");
            }
        })
    }

    render(props) {
        if(!this.state.loading_deactivate) {
            return (
                <PopupModal 
                // headerText="Deactivate User"
                    headerIcon='UserDeactivate'
                    headerIconStyle={{backgroundColor: colours.primary.grey04, borderRadius: '8px', color: colours.primary.grey02}}
                    close={this.props.closeModal}
                    content={(
                        <div id = "deactivateuser-overlay" style={{width: '100%'}}>
                            <div>
                                <div>
                                    <div className = "row mb-16">
                                        <h6><Trans>Are you sure you want to deactivate</Trans> {this.state.name}?</h6>
                                        <span className = "black-light">{this.state.bookings_message}</span>
                                    </div>
                                    <Input
                                        name="notes"
                                        textarea
                                        label="Deactivation Notes"
                                        placeholder="This note is for your own records and will not be shared with the user." 
                                        onChange={(e) => this.handleChange(e, props)} 
                                    />
                                </div>
                                
                                <div className = "card-button-section">
                                    {/* <a className = "button alert float-right" onClick={this.handleSubmit}><Trans>Deactivate</Trans></a>
                                    <a className = "button float-right" onClick={this.props.history.goBack}><Trans>Cancel</Trans></a> */}
                                    <div style={{display: 'flex', flexDirection: 'row', flex: 2, justifyContent: 'center', alignItems: 'center'}}>
                                        <Button 
                                            label='Cancel' 
                                            secondary 
                                            large 
                                            onClick={this.props.history.goBack} 
                                            containerProps={{style: {display: 'flex' , flex: 1, maxWidth: '172px'}}} 
                                            style={{flex: 1}}/>
                                        <div style={{width: '24px'}}></div>
                                        <Button 
                                            label='Deactivate' 
                                            primary
                                            large
                                            red
                                            onClick={this.handleSubmit} 
                                            containerProps={{style: {display: 'flex' , flex: 1, maxWidth: '172px'}}} 
                                            style={{flex: 1}}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                />
            )
        } else {
            return (
                <LoadingIcon />
            )
        }
        
    }
}

const mapStateToProps = store => ({
    userSession: store.userSession,
    data: store.data,
    stakeholder: store.stakeholder
})

export default connect(mapStateToProps)(DeactivateUserOverlay)